export const getCpaTitle = resultsName => {
  if (!resultsName) {
    return 'CPA'
  }

  if (resultsName === 'Conversions') {
    // if the conversion name is 'Conversions' then the CPA title should be 'CPA'
    return 'CPA'
  }

  const allInitialLetters = resultsName && resultsName.match(/\b\w/g)
  return 'CP' + allInitialLetters?.join('').toUpperCase()
}
